import React from 'react';
import { FaCouch, FaHome, FaPencilRuler, FaBuilding, FaRoad, FaPaintRoller } from 'react-icons/fa';
import { MdLocalParking, MdFoodBank, MdOutlineBrightnessAuto, MdOutlinePayment, MdOutlineScreenshot, MdDirectionsCar} from 'react-icons/md'
import { FaCrown } from "react-icons/fa6";

// Function to render the appropriate icon based on the service name
export const renderIcon = (serviceName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = serviceName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {
    case '⼤潤發量販發票折抵⾃動歸⼾':
      return <MdDirectionsCar />; // Return the FaCouch icon for interior design
    case '商店美食街折抵':
      return <MdFoodBank />; // Return the FaHome icon for exterior design
    case '直接離場免等待':
      return <FaCrown />; // Return the FaPencilRuler icon for architectural design
    case '綁定繳費⽅式輕鬆付':
      return <MdOutlinePayment />; // Return the FaBuilding icon for building construction
    case '隨時查詢停⾞費':
      return <MdOutlineScreenshot />; // Return the FaRoad icon for road repair
    case 'renovation':
      return <FaPaintRoller />; // Return the FaPaintRoller icon for renovation
    case 'rental': 
    return <MdDirectionsCar />; // Return the FaCouch icon for interior design
    default:
      return null; // If no matching service name is found, return null
  }

};